var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,60c-15.4395,0-28-12.5605-28-28S16.5605,4,32,4s28,12.5605,28,28-12.5605,28-28,28Zm0-54c-14.3364,0-26,11.6636-26,26s11.6636,26,26,26,26-11.6636,26-26S46.3369,6,32,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.376,28h-8.376c-.3145,0-.6113-.1484-.7998-.3999l-1.7998-2.3999c-.5645-.7515-1.4609-1.2002-2.4004-1.2002h-14c-.9395,0-1.8369,.4487-2.4004,1.2002l-1.7998,2.3999c-.1885,.2515-.4849,.3999-.7998,.3999H11.624c-.3071,0-.5972-.1411-.7866-.3828-.1895-.2412-.2578-.5566-.1846-.855,2.415-9.8691,11.1934-16.7622,21.3472-16.7622s18.9326,6.8931,21.3477,16.7622c.0723,.2983,.0049,.6138-.1846,.855-.1904,.2417-.4805,.3828-.7871,.3828Zm-7.876-2h6.5596c-2.5977-8.3052-10.2598-14-19.0596-14s-16.4624,5.6948-19.0601,14h6.5601l1.5-2c.939-1.2524,2.4346-2,4-2h14c1.5654,0,3.0605,.7476,4,2l1.5,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,53.6133c-.063,0-.127-.0059-.1899-.0181-9.1753-1.7739-16.2329-9.1895-17.561-18.4531-.0415-.2871,.0439-.5781,.2339-.7969,.1899-.2192,.4658-.3452,.7559-.3452h.7612c9.374,0,17,7.626,17,17v1.6133c0,.2983-.1333,.5815-.3638,.7715-.1802,.1489-.4058,.2285-.6362,.2285Zm-15.5728-17.6074c1.521,7.4829,7.1919,13.4575,14.5728,15.3579v-.3638c0-8.1279-6.4985-14.7671-14.5728-14.9941Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,53.6133c-.2305,0-.4561-.0796-.6367-.2285-.2295-.1899-.3633-.4731-.3633-.7715v-1.6133c0-9.374,7.626-17,17-17h.7617c.29,0,.5654,.126,.7559,.3452,.1895,.2188,.2754,.5098,.2344,.7969-1.3291,9.2637-8.3867,16.6792-17.5625,18.4531-.0625,.0122-.126,.0181-.1895,.0181Zm15.5732-17.6074c-8.0742,.2271-14.5732,6.8662-14.5732,14.9941v.3638c7.3809-1.9004,13.0518-7.875,14.5732-15.3579Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,40c-3.3086,0-6-2.6914-6-6s2.6914-6,6-6,6,2.6914,6,6-2.6914,6-6,6Zm0-10c-2.2056,0-4,1.7944-4,4s1.7944,4,4,4,4-1.7944,4-4-1.7939-4-4-4Z"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "a`"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "aa"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "ab"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "ac"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "ad"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "ae"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "af"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrim);
export default __webpack_public_path__ + "static/media/Trim.a2b69ec98e0e66b2399a1509054f9b32.svg";
export { ForwardRef as ReactComponent };